import { GetAllLaboratoryDTO, GetAllLaboratoryFiltersDTO, GetAllSampleCollectionDTO, GetAllSampleCollectionFiltersDTO, SampleCollectionCreationDTO, SampleCollectionDTO, SampleCollectionUpdateDTO } from "./dto";
import { LaboratoryServiceImpl, SampleCollectionServiceImpl } from "./serviceImpl";

export interface SampleCollectionService {
    CreateSampleCollection(data: SampleCollectionCreationDTO): Promise<void>
    UpdateSampleCollection(data: SampleCollectionUpdateDTO, id: string): Promise<void>
    DeleteSampleCollection(id: string): Promise<void>
    GetAllSampleCollection(filters: GetAllSampleCollectionFiltersDTO): Promise<GetAllSampleCollectionDTO>
    GetSampleCollectionById(id: string): Promise<SampleCollectionDTO>
}

export interface LaboratoryService {
    // CRUD TO IMPLEMENT
    GetAllLaboratory(filters: GetAllLaboratoryFiltersDTO): Promise<GetAllLaboratoryDTO>
}

export function NewSampleCollectionService(): SampleCollectionService {
    return new SampleCollectionServiceImpl()
}

export function NewLaboratoryService(): LaboratoryService {
    return new LaboratoryServiceImpl()
}